<template>
<div class="navbar">
  <div class="navbar-body">
    <div class="logo" @click="goTo('HomePage')">
      <img :src="require('@/assets/logo.png')" class="logo__image">
      <!-- <span class="slogan">{{__('for a better seat')}}</span> -->
    </div>

    <div style="display: flex;">
      <el-button secondary margin-right
        v-if="currentPage !== 'HomePage'"
        @click="goTo('HomePage')"
        >
        {{__('Home')}}
      </el-button>
      <el-button secondary margin-right
        v-if="currentPage !== 'StoriesPage'"
        @click="goTo('StoriesPage')"
        >
        {{__('Stories')}}
      </el-button>
      <el-button
        @click="goToOrder()"
        >
        {{__('Buy now')}}
      </el-button>
    </div>
  </div>
</div>
</template>
<script>
import analytics from 'services/analytics.js'

export default {
  data () {
    return {
      currentPage: ''
    }
  },
  mounted () {
    this.checkPage()
  },
  methods: {
    goTo (name) {
      this.$router.push({ name })
      this.checkPage()
    },
    goToOrder () {
      const isOrderPage = this.$router.currentRoute && this.$router.currentRoute.name === 'OrderPage'

      const name = isOrderPage ? 'CheckoutPage' : 'OrderPage'

      if (name === 'CheckoutPage') {
        analytics.log('addToCart')
      }

      this.$router.push({ name })
      this.checkPage()
    },
    checkPage () {
      if (!this.$router.currentRoute) {
        return
      }

      this.currentPage = this.$router.currentRoute.name
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../style/variables.less';

  .navbar {
    // background-color: @color-grey-dark;
    background-color: #fff;
    box-shadow: @shadow;
    position: fixed;
    top: 0px;
    left: 0px;
    height: 50px;
    width: 100%;
    z-index: 100;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    @media (max-width: @width-max) {
      padding: 10px;
    }

    @media (max-width: 500px) {
      height: 40px;

      .el-button {
        padding-left: 5px;
        padding-right: 5px;
        margin-right: 5px;
      }
    }
  }

  .navbar-body {
    width: @width-max;
    max-width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    display: flex;
    align-items: center;

    &__image {
      cursor: pointer;
      height: 30px;
      width: auto;

      @media (max-width: 500px) {
        margin-top: 7px;
        height: 20px;
      }
    }
  }

  .slogan {
    color: @color-brand;
    font-size: @font-size-medium;
    font-family: @font-family-text;

    @media (max-width: 500px) {
      display: none;
    }
  }
</style>
